module.exports = __webpack_public_path__ + "static/media/a62.19667777.jpg";